import { TaskParameter } from './task-parameter.model';
import { CheckListItem } from './checkListItem.model';

import { Moment } from 'moment';
import { SystemTask } from './systemTask.model';

export interface Task {
  swimlaneLabel: any;
  swimlaneId: string;
  dueByDate: Moment;
  taskId: string;
  name: string;
  description: string;
  taskState: string;
  taskStateId: string;
  systemTaskId: string;
  parameterId: string;
  isSystemTask: boolean;
  checkListItems: CheckListItem[];
  dueBy: any;
  notes: string;
  recurrenceRule?: string;
  taskSeriesId?: string;
  userId: string;
  relatedUserId: string;
  assignmentGroupId: string;
  parameterDto: TaskParameter;
  systemTaskTypeDto: SystemTask;
}
